<template>
  <div>
    <b-row>
      <b-col md="6" lg="3">
        <b-form-group :label="$t('carpetline.kwaliteitsnaamenkleur')" class="form-label">
            <b-input v-model="command.qualityName" id="qualityName" type="text"/>
            <validation element="qualityName" message="Geef een kwaliteit &amp; kleur op"/>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="3">
        <b-form-group :label="$t('order.afwerking')" class="form-label">
          <b-form-select id="semiFinish" v-model="command.semiFinishId">
              <option value="">--- {{$t('carpetline.kieseenafwerking')}} ---</option>
              <option v-for="item in semiFinishes" v-bind:key="item.id" :value="item.id">{{ item.description }}</option>
          </b-form-select>
          <validation element="article_id" message="Selecteer een afwerking"/>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="3">
        <b-form-group :label="$t('carpetline.afwerkingsoptie')" class="form-label">
          <b-form-select id="article" v-model="command.articleId" :disabled="articles.length == 0">
            <option value="">--- {{$t('carpetline.kieseenafwerkingsoptie')}} ---</option>
            <option v-for="item in articles" v-bind:key="item.id" :value="item.id">{{ item.description }}</option>
          </b-form-select>
          <validation element="article_option" message="Selecteer een afwerkings optie"/>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="3">
        <b-form-group :label="$t('carpetline.kleur')" class="form-label">
          <b-form-select id="color" v-model="command.colorId" :disabled="colors.length == 0">
            <option value="">--- {{$t('carpetline.kieseenkleur')}} ---</option>
            <option v-for="item in colors" v-bind:key="item.id" :value="item.id">{{ item.description }}</option>
          </b-form-select>
          <validation element="article_option_color_id" message="Selecteer een kleur"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" lg="3">
      <b-form-group :label="$t('carpetline.vorm')" class="form-label">
        <b-form-select id="shape" v-model="command.shape">
          <option value="0">{{$t('carpetline.recht')}}</option>
          <option value="1">{{$t('carpetline.rond')}}</option>
          <option value="2">{{$t('carpetline.afwijkend')}}</option>
        </b-form-select>
        </b-form-group>
      </b-col>
      <b-col v-if="command.shape == 0" md="6" lg="3">
        <b-form-group :label="$t('carpetline.lengteincentimeters')" class="form-label">
          <b-input id="length" class="form-control" min="1" v-model="command.length" type="number" />
          <validation element="length" message="Geef een lengte in centimeters op"/>
        </b-form-group>
      </b-col>
      <b-col v-if="command.shape == 0" md="6" lg="3">
        <b-form-group :label="$t('carpetline.breedteincentimeters')" class="form-label">
        <b-input id="width" class="form-control" min="1" v-model="command.width" type="number" />
        <validation element="width" message="Geef een breedte in centimeters op"/>
        </b-form-group>
      </b-col>
      <b-col v-if="command.shape == 1" md="6" lg="6">
        <b-form-group :label="$t('carpetline.diameterincentimeters')" class="form-label">
        <b-input id="diameter" class="form-control" min="1" v-model="command.diameter" type="number" />
        <validation element="diameter" message="Geef een diameter in centimeters op"/>
        </b-form-group>
      </b-col>
      <b-col v-if="command.shape == 2" md="6" lg="6">
        <b-form-group :label="$t('priceagreements.bijlage')" class="form-label">
        <b-form-file id="attachment" v-model="command.attachment.content"></b-form-file>
        <validation element="attachment" message="Selecteer een bijlage"/>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="3">
        <b-form-group :label="$t('carpetline.aantal')" class="form-label">
        <numeric-input id="quantity" class="form-control" v-model="command.quantity" type="number" min="1" steps="1"/>
        <validation element="count" message="Geef een aantal op"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">      
        <b-btn size="sm" id="addButton" v-on:click="addNewLine" variant="themecolor" class="waves-effect pull-right">
          {{$t('buttons.regeltoevoegen')}}
        </b-btn>
      </b-col>
    </b-row>
  </div>
</template>
<script>

//Import store
import { mapActions, mapGetters } from "vuex";

//Import orderLine
import Command from "./command";

import $ from 'jquery';

export default {
  name: "orderlines-form",
  data() {
    return {
      command: new Command(),
      selectedSemiFinish: {},
      selectedArticle: {},
      selectedColor: {},
      articles: [],
      colors: []
    };
  },
  computed: {
    ...mapGetters("carpetline", ["orders", "semiFinishes"])
  },
  watch: {
    selectedSemiFinish: function(semiFinish) {
      if (Object.keys(semiFinish).length == 0) {
        return;
      }

      this.command.semiFinishId = semiFinish.id;
      this.command.semiFinishDescription = semiFinish.description;

      if (semiFinish.articles.length == 0) {
        this.selectedArticle = {};
        this.colors = semiFinish.colors;
      } else {
        this.articles = semiFinish.articles;
      }
    },
    selectedArticle: function(article) {
      this.command.articleId =
        Object.keys(article).length !== 0 ? article.id : "";
      this.command.articleDescription =
        Object.keys(article).length !== 0 ? article.description : "";

      if (Object.keys(article).length == 0 || article.colors.length == 0) {
        this.selectedColor = {};
      } else {
        this.colors = article.colors;
      }
    },
    selectedColor: function(color) {
      this.command.colorId = Object.keys(color).length !== 0 ? color.id : "";
      this.command.colorDescription =
        Object.keys(color).length !== 0 ? color.description : "";
    },
    "command.semiFinishId": function(semiFinishId) {
      this.articles = [];
      this.colors = [];

      const result = this.semiFinishes.filter(({ id }) => id == semiFinishId);
      if (result.length > 0) {
        this.selectedSemiFinish = result[0];

        $("#article")
          .parent()
          .toggleClass("has-danger", false);
        $("#color")
          .parent()
          .toggleClass("has-danger", false);
      }
      $("#semiFinish")
        .parent()
        .toggleClass("table-danger", false);
    },
    "command.articleId": function(articleId) {
      this.colors = [];

      const result = this.articles.filter(({ id }) => id == articleId);
      if (result.length > 0) {
        this.selectedArticle = result[0];
      }
      $("#color")
        .parent()
        .toggleClass("has-danger", false);
    },
    "command.colorId": function(colorId) {
      const result = this.colors.filter(({ id }) => id == colorId);
      if (result.length > 0) {
        this.selectedColor = result[0];
      }
    },
    "command.shape": function() {
      this.command.width = "";
      this.command.length = "";
      this.command.diameter = "";
    }
  },
  methods: {
    ...mapActions("carpetline", ["all"]),
    addNewLine() {
      const vm = this;

      if (!vm.validateInputs()) {
        return;
      }

      if (vm.command.attachment.content.size > 0) {
        vm.command.attachment.name = vm.command.attachment.content.name;

        var reader = new FileReader();
        reader.readAsDataURL(vm.command.attachment.content);
        reader.onload = function() {
          vm.command.attachment.content = reader.result;

          vm.emitNewLine();
        };
      } else {
        vm.command.attachment = null;
        vm.emitNewLine();
      }

      vm.selectedSemiFinish = {};
      vm.selectedArticle = {};
      vm.selectedColor = {};
      vm.articles = [];
      vm.colors = [];
    },
    emitNewLine() {
      const vm = this;
      const currentIndex = vm.command.lineNumber;

      vm.$emit("add-new-line", vm.command);
      vm.command = new Command();
      vm.command.lineNumber = currentIndex + 1;
    },
    validateInputs() {
      let allCorrect = true;
      // qualityName check
      $("#qualityName")
        .parent()
        .toggleClass("has-danger", false);
      $("#length")
        .parent()
        .toggleClass("has-danger", false);
      $("#width")
        .parent()
        .toggleClass("has-danger", false);
      $("#semiFinish")
        .parent()
        .toggleClass("has-danger", false);
      $("#article")
        .parent()
        .toggleClass("has-danger", false);
      $("#color")
        .parent()
        .toggleClass("has-danger", false);
      $("#attachment")
        .parent()
        .toggleClass("has-danger", false);

      if (this.command.qualityName === "") {
        allCorrect = false;
        $("#qualityName")
          .parent()
          .toggleClass("has-danger", true);
      }

      switch (this.command.shape) {
        case "0", 0: // recht
          //length check
          if (this.command.length === "") {
            allCorrect = false;
            $("#length")
              .parent()
              .toggleClass("has-danger", true);
          }

          // width check
          if (this.command.width === "") {
            allCorrect = false;
            $("#width")
              .parent()
              .toggleClass("has-danger", true);
          }
          break;
        case "1", 1:  // rond
          if (this.command.diameter === "") {
            allCorrect = false;
            $("#diameter")
              .parent()
              .toggleClass("has-danger", true);
          }
          break;
        case "2", 2: // afwijkend
          if (!this.command.attachment.content.size) {
            allCorrect = false;
            $("#attachment")
              .parent()
              .toggleClass("has-danger", true);
          }
          break;
      }

      // semiFinish check
      if (this.command.semiFinishId === "") {
        allCorrect = false;
        $("#semiFinish")
          .parent()
          .toggleClass("has-danger", true);
      }

      //article check
      if (this.command.articleId === "" && this.articles.length !== 0) {
        allCorrect = false;
        $("#article")
          .parent()
          .toggleClass("has-danger", true);
      }

      // color check
      if (this.command.colorId === "" && this.colors.length !== 0) {
        allCorrect = false;
        $("#color")
          .parent()
          .toggleClass("has-danger", true);
      }

      return allCorrect;
    }
  },
  created() {
    var vm = this;
    vm.all({
      resource: "semi-finishes"
    });
  }
};
</script>
